// extracted by mini-css-extract-plugin
module.exports = {"block":"OtherInfo_block__13azs","title":"OtherInfo_title__NY_0j","event":"OtherInfo_event__11Z16","btn":"OtherInfo_btn__2RQyR"};